// Default state for the meta object
export default () => ({
    line1: null,
    line2: null,
    city: null,
    town:  null,
    stateOrProvince: null,
    country: null,
    postalCode: null,
    firstName: null,
    emailAddress: null,
    marketType: null,
    offerId: null,
    features:  null,
    channels: null,
    uuid: null,
    acsid: null,
    impactRadiusClickId: null,
    conversationId: null,
    locationId: null,
    billerMappingCode: null,
    isCurrentCustomer: null,
    createdConversation: null,
    pendingDisconnect: {
        hasPendingDisconnect: false,
        date: null,
    },
    customerState: null,
    channelLineup:  null,
    businessPromotion:  null,
    rateCard: "",
    lastName: "",
    phoneNumber: "",
    billingLine1: "",
    billingLine2: "",
    billingCity: "",
    billingStateOrProvince: "",
    billingPostalCode: "",
    referralCode: "",
    referralCodeUsed: false,
    mobileEligible: false,
    abandonedCart: {
        giftCardTrigger: null,
    },
    houseKey: null,
    statusCode: null,
    dwellingType: null,
    isRightOfEntry: null,
    roeRedirect: null,
    isAbandonedCart: null,
})
